import { create } from "zustand";

interface DocuSignState {
	isModalOpen: boolean;
	signingUrl: string | null;
	error: string | null;
}

interface DocuSignActions {
	openSigningModal: (url: string) => void;
	closeSigningModal: () => void;
	setSigningError: (message: string) => void;
	clearError: () => void;
}

interface DocuSignStore extends DocuSignState {
	actions: DocuSignActions;
}

const useDocuSignStore = create<DocuSignStore>((set) => {
	const state: DocuSignState = {
		isModalOpen: false,
		signingUrl: null,
		error: null,
	};

	const actions: DocuSignActions = {
		openSigningModal: (url: string) =>
			set({
				isModalOpen: true,
				signingUrl: url,
				error: null,
			}),

		closeSigningModal: () =>
			set({
				isModalOpen: false,
				signingUrl: null,
				error: null,
			}),

		setSigningError: (message: string) =>
			set({
				error: message,
				isModalOpen: false,
				signingUrl: null,
			}),

		clearError: () =>
			set({
				error: null,
			}),
	};

	return {
		...state,
		actions,
	};
});

export const useIsModalOpen = () =>
	useDocuSignStore((state) => state.isModalOpen);
export const useSigningUrl = () =>
	useDocuSignStore((state) => state.signingUrl);
export const useSigningError = () => useDocuSignStore((state) => state.error);
export const useDocuSignActions = () =>
	useDocuSignStore((state) => state.actions);
